import React from 'react'
import CountUp from "react-countup";
import './Main.css'

const Main = () => {
  return (
    <main>
      <div className="cards">

        <div className="card">
          <div className="">
            <h1>
              <CountUp
                start={0}
                end={87}
                duration={2.5}
                separator=","
              />
            </h1>
            <span className="card-text">Users</span>
          </div>
          <div className="">
            <span><img alt="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABkElEQVRIS8VV0VHCQBB9i0Ni8Ac60ArUCsQOsAKgAsYKhArECtQKhAqEDuiAEuRHD8LIc+5MnCRc7hiR8b5ukux7u+/tbgQHPnJgfOxEsHpnSyroAWgmCU0EGFQjmfgS9BLEik8A2jYgAoMwkr6LxEmQZP5iAIjbT8FIXytAR4A7fRfg2lWJkyBW1BJcafCgJsNspivFfkIyDSJJpdsqxkdAHVFdoiENWWSjleLpETDXz4JISnH+ncBIZDMzlYjEOKxJq8zonU0m0N8Az4nJbQFM9+xlsgbImLmV5N5tmiKuFZu6AtNR32eqK/iTQfNNqu99qQd8Yz0+Rk+IFgQXViBiRsEoWOKh2Mbp91aCWLED4h6Cui/DZMoXJLrhiZhJz54tAgMOPJrtQIwrgmGZ1kVvuMFNkSRHoGVZh5gnmXeDSPSi856fTiMW1RXOsnLlCHYdHhtjureKrZsjiD84g+DcNzw2gkSuVxCzoCaXVpNjRbPcXMvLpZctPl/BoQm8bv7iA+8v8xeY7jnYF7AY/wV9mbQZDXeNbwAAAABJRU5ErkJggg==" /></span>
          </div>
        </div>
        <div className="card">
          <div className="">
            <h1>$
              <CountUp
                start={0}
                end={15}
                duration={2.5}
                separator="."
              />K
            </h1>
            <span className="card-text">Revenue</span>
          </div>
          <div className="">
            <span><img alt="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABXElEQVRIS92V0VHCQBCGv4UxmeRFqECoQKhAO9AStAKxAqACsQIpQTvQCowVCBWIL0TixHUuk2MCDHBoeOEec3v/v/vvvxthz0f2jM8BESRTjRBOS5FMibxQ2gZrLlESq5YCnoN4gWTYmwjGXiANF9Ik1glwXIzdSqDQ9wPpuRDMYu0JdF0JxgrDIngca6Oi3InQMiCqRD/CbRDIyIImUx0gXAIn5tvaCuyFfWjAq8orQm2hGmWSCu0iibm3vXQmmE31UYQL4CWFKwNShSFwpsqTH4rJen52JrANTKFps82qgndg5AXSLIXg6Iu61MW4hQLBitN2rqAg0XMK17lED8B5KRLl2UbLPgc+U2jt3GSja27TftFJFWWwZNOOBdcPrX37dHObZsO5ddBQ7r1QOi6Dls/Ajeug2bgVh6wj+9OqcMl8U8yqROWu6zcvlGytHNAf7b+ar3u/d4l+ARIRzxlXEtpDAAAAAElFTkSuQmCC" /></span>
          </div>
        </div>

        <div className="card">
          <div className="">
            <h1>
              <CountUp
                start={0}
                end={1000}
                duration={2.5}
                separator=","
              />
            </h1>
            <span className="card-text">Network</span>
          </div>
          <div className="">
            <span><img alt="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAB10lEQVRIS7WV/03bcBDFP1cUWw6VSiZomIB0goQJSiconaBsQNgAJiAbABM0TECYoDBBE6nFxJVz6KyvTWJ/HcUo3D+JTvm+d+/djwjvHPLO+FQI5v/0SD7wExgAY11wEe7K9VsLWSFw4FdlMF3wbR1J8qTnCF/tncIojOQsx1ghSJ50gnCgcBZGMpzHOhQ4BW6DSExRJRy4KS4if2+JVYJY1ZJBJEU+8eSWwZJYp8AnUr5k+R3ugIcgkv0qwauCocksFCj3QVt6XgV+gscgkm6FoK4HKJPWnEPpiFW7ErmtG1lkP3IkJ0Af5T57KBwYCcIEOEaZIuSTdQzMHMHUNXnobbLPAv2je/9DxhmJP2akDIKPYuSV2GjRklhHwHebptQUZL3Ecn1VbsK2HNWQVxetppHZdKWwH0XyYN/jWLs78Ls8deX3myrIRrH1TCdv9BJBMTHbsGicwg9n0aWdk+1Y9Fd7boHKRc5S6OW2vUmBm6JfCLZoj8Bn+1RlshBO1oFXFi2voDheyh6C+d+1nWjNGfiWrW6CvAS+42UVt57pNQX3E/huizIN2tJZV+nGe1BzHdeOYiOLlv4DinfL972pCu+iOZLsJJSP11YImoI0smib4Ib1AnsB1hmZNUKuAAAAAElFTkSuQmCC" /></span>
          </div>
        </div>

        <div className="card">
          <div className="">
            <h1>
              <CountUp
                start={0}
                end={8}
                duration={2.5}
                separator=","
              />
            </h1>
            <span className="card-text">Award</span>
          </div>
          <div className="">
            <span><img alt="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAB4klEQVRIS+2U4XHTQBCFvxUj2TLM2OmAVJBQQUIHTgdOBbgDnApwKoAOUCrA6cCpgHQQZwawLU+0zJ5PHsGcrMhM/rF/NHN32rf73tsVXjjkhfOzFyBfqlYLSFJx7+vOQ8X+B3CslNQdStEtSkbBLHkjc6fBDz0l4hxhCJwdDLBZ6nmcymyf05reNNpUH3SQd/kgyhDh1IEpcxWyZMW1HMliXwFNLhqhfEIYBJMoC1UuO68lqwOpBciXOgI+u4KVm0iYlnQZLQoT49/dF1zUgQQBjJZNh+++8ssklS+WyBLbtwRaL3Ui8BFlEa85DtEVBCh/tMo7PTGnuMiXaoJrksr7v87OFK46qVhXf0QQIP+lc4QTAZeoiOjLk7Pl2Is81VfMogITWBS+mfBJT949D8DvIPN3VYuAkI6+cjeF5iHcQQXAU7MTvAKy06Y9QIUiE9SJ3uWh2kG84shEXf/UoUR8RblLerKdk0o0iZx1enLhbZkpTO1fgbHA0MC98O1E9hXfA33zuzxxE2+4L21o96sugwhGzqbwGK94+2ybWpW71rftzgQmcSq35TzoNrGbi9aDVvG4iWu09AMOsqNHLRgdtCrKhH7Zjf2yO/FzcOeX3fSfll1N1a2OG9d1q2yBx78BmSgFKMaZjuIAAAAASUVORK5CYII=" /></span>
          </div>
        </div>
      </div>

      <div className="main-macros">

        <div className="main-projects">
          <div className="card sticky" id="projects">
            <div className="card-header">
              <h3>Exclusive Projects</h3>
              <button>See all <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA2UlEQVRIS9XWvQrCMBQF4HOGtEnVB/KRRDCLq5urm6ubs5Ozk1AfwNnN1U0EkUY0FURa2rS9g1kD58vvTQjhRuF8FAL3m0tBJHQYK8N9m0GUAe4TSmCmDOdNkUogD965B2w84DEUqgu8cjMQNtJchiAhwDvXOWwigwnJcx0oGMhDLw6wseG6CmkK+FxipWJYktcyqB3gU09ZBqt73BYhXQB+MsRCaU5/kc4AfwJwiBIOv5H/ASSXSHCTBY+p3EWTLBWixU6uXEs9OCmAPoGRyJNZVYJD+sV/FU8MO4EZBd9ZowAAAABJRU5ErkJggg==" alt="" /></button>
            </div>
            <div className="card-content">
              <div className="responsive-tab">

                <table style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <td>Project Title</td>
                      <td>Speciality</td>
                      <td>Status</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Cynos ltd</td>
                      <td>Web development</td>
                      <td><span className="status green"></span></td>
                    </tr>
                    <tr>
                      <td>Albatros design</td>
                      <td>UI/UX</td>
                      <td><span className="status purple"></span></td>
                    </tr>
                    <tr>
                      <td>Alan AI</td>
                      <td>Artificial Intelligence</td>
                      <td><span className="status green"></span></td>
                    </tr>
                    <tr>
                      <td>Doge coin</td>
                      <td>Blockchain</td>
                      <td><span className="status dark"></span></td>
                    </tr>
                    <tr>
                      <td>Sirius oclave</td>
                      <td>AR/VR</td>
                      <td><span className="status purple"></span></td>
                    </tr>
                    <tr>
                      <td>Uno chip</td>
                      <td>IoT</td>
                      <td><span className="status dark"></span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <td><span className="status green"></span>review</td>
          <td><span className="status purple"></span>stage</td>
          <td><span className="status dark"></span>development</td>
        </div>

        <div className="main-customers">
          <div className="card sticky">
            <div className="card-header">
              <h3>Customers</h3>
              <button>See all <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA2UlEQVRIS9XWvQrCMBQF4HOGtEnVB/KRRDCLq5urm6ubs5Ozk1AfwNnN1U0EkUY0FURa2rS9g1kD58vvTQjhRuF8FAL3m0tBJHQYK8N9m0GUAe4TSmCmDOdNkUogD965B2w84DEUqgu8cjMQNtJchiAhwDvXOWwigwnJcx0oGMhDLw6wseG6CmkK+FxipWJYktcyqB3gU09ZBqt73BYhXQB+MsRCaU5/kc4AfwJwiBIOv5H/ASSXSHCTBY+p3EWTLBWixU6uXEs9OCmAPoGRyJNZVYJD+sV/FU8MO4EZBd9ZowAAAABJRU5ErkJggg==" alt="" /></button>
            </div>
            <div className="card-content">
              <div className="customer">
                <div className="">
                  <img src="https://img.icons8.com/plasticine/100/000000/user-male.png" alt="" />
                  <div className="">
                    <h4>Tom Shelb</h4>
                  </div>
                </div>
                <div className="">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA40lEQVRIS92V0QnCMBRFzxMaCPihE6gbOIKj2A26iSO0buIIukHdQEGoVDDSQktbq7WN+dD3mfDuyb0JL4LjEsf6lIBbYlYGQmBuCY0FfE/LLtMpAWliYmBmKV60x0rLogkw2YLSYhVbmpiaTtXBHwIKu133Uo21V0TOAV0nb9vv5cA54F1Er55zLwfOAc4j+l1AejFLRoQIyyEugKPSkk/lp1kE+Bg2CJOh4gLrtnGdD7tKbb0rgUzlNBCUt7U5OAOB0hLZCBe9dYDhwJ21Gsv+G+JNB9E3ImkezOr3+sSlc8ADYgSoGXBQY4YAAAAASUVORK5CYII=" alt="" />
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABdklEQVRIS9WV3VGDQBSFz00mSzYvagXGCtQKjBWYVKDpQCswdoAVmFSQWIHYAXZgB/IiCA5eZzMLAmEz/Jhx3Ed+zrdnOedC2PGiHevjbwCRzzYDhyLElA7Ia+My54DfeP+zjyWAkRZ1hKTzXwNEPrsgHBcE50LStCkk5yAKmA1CjSFVAQDjRgzIruukCHAAnJWJMOPRGtC4LWAO4HJDhPHSCzFqkqicg/Cdx9RZp+hntRBXImUxfQWwlxBi4EhKUtcarY0mRwHnjomBO0vSrJF60YESCQIedgE3dcHwYsJp0YUqZWThgTpwRJ/uTRsonUVhwDMCbtOXGG5MmCSQdeMtPIFwop8x9sQ47EKfV0S4yEA8JthfwKLLWGbEk0dKIUaA3qVTMjq2fQ6n94FJNs5bx7UefitT+QykhZB0ldyr9D/Q3+Q6G1+TjWLqKgEy6VJxVeMi7UkB9CwkJaN+fasyIBHSx6YgSmiYHp+h8bUBdQv3/wHf0lmLGXoisCQAAAAASUVORK5CYII=" alt="" />
                </div>
              </div>
              <div className="customer">
                <div className="">
                  <img src="https://img.icons8.com/dusk/64/000000/user.png" alt="" />
                  <div className="">
                    <h4>Sirius Black</h4>
                  </div>
                </div>
                <div className="">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA40lEQVRIS92V0QnCMBRFzxMaCPihE6gbOIKj2A26iSO0buIIukHdQEGoVDDSQktbq7WN+dD3mfDuyb0JL4LjEsf6lIBbYlYGQmBuCY0FfE/LLtMpAWliYmBmKV60x0rLogkw2YLSYhVbmpiaTtXBHwIKu133Uo21V0TOAV0nb9vv5cA54F1Er55zLwfOAc4j+l1AejFLRoQIyyEugKPSkk/lp1kE+Bg2CJOh4gLrtnGdD7tKbb0rgUzlNBCUt7U5OAOB0hLZCBe9dYDhwJ21Gsv+G+JNB9E3ImkezOr3+sSlc8ADYgSoGXBQY4YAAAAASUVORK5CYII=" alt="" />
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABdklEQVRIS9WV3VGDQBSFz00mSzYvagXGCtQKjBWYVKDpQCswdoAVmFSQWIHYAXZgB/IiCA5eZzMLAmEz/Jhx3Ed+zrdnOedC2PGiHevjbwCRzzYDhyLElA7Ia+My54DfeP+zjyWAkRZ1hKTzXwNEPrsgHBcE50LStCkk5yAKmA1CjSFVAQDjRgzIruukCHAAnJWJMOPRGtC4LWAO4HJDhPHSCzFqkqicg/Cdx9RZp+hntRBXImUxfQWwlxBi4EhKUtcarY0mRwHnjomBO0vSrJF60YESCQIedgE3dcHwYsJp0YUqZWThgTpwRJ/uTRsonUVhwDMCbtOXGG5MmCSQdeMtPIFwop8x9sQ47EKfV0S4yEA8JthfwKLLWGbEk0dKIUaA3qVTMjq2fQ6n94FJNs5bx7UefitT+QykhZB0ldyr9D/Q3+Q6G1+TjWLqKgEy6VJxVeMi7UkB9CwkJaN+fasyIBHSx6YgSmiYHp+h8bUBdQv3/wHf0lmLGXoisCQAAAAASUVORK5CYII=" alt="" />
                </div>
              </div>
              <div className="customer">
                <div className="">
                  <img src="https://img.icons8.com/doodle/48/000000/user.png" alt="" />
                  <div className="">
                    <h4>Ratan Tata</h4>
                  </div>
                </div>
                <div className="">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA40lEQVRIS92V0QnCMBRFzxMaCPihE6gbOIKj2A26iSO0buIIukHdQEGoVDDSQktbq7WN+dD3mfDuyb0JL4LjEsf6lIBbYlYGQmBuCY0FfE/LLtMpAWliYmBmKV60x0rLogkw2YLSYhVbmpiaTtXBHwIKu133Uo21V0TOAV0nb9vv5cA54F1Er55zLwfOAc4j+l1AejFLRoQIyyEugKPSkk/lp1kE+Bg2CJOh4gLrtnGdD7tKbb0rgUzlNBCUt7U5OAOB0hLZCBe9dYDhwJ21Gsv+G+JNB9E3ImkezOr3+sSlc8ADYgSoGXBQY4YAAAAASUVORK5CYII=" alt="" />
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABdklEQVRIS9WV3VGDQBSFz00mSzYvagXGCtQKjBWYVKDpQCswdoAVmFSQWIHYAXZgB/IiCA5eZzMLAmEz/Jhx3Ed+zrdnOedC2PGiHevjbwCRzzYDhyLElA7Ia+My54DfeP+zjyWAkRZ1hKTzXwNEPrsgHBcE50LStCkk5yAKmA1CjSFVAQDjRgzIruukCHAAnJWJMOPRGtC4LWAO4HJDhPHSCzFqkqicg/Cdx9RZp+hntRBXImUxfQWwlxBi4EhKUtcarY0mRwHnjomBO0vSrJF60YESCQIedgE3dcHwYsJp0YUqZWThgTpwRJ/uTRsonUVhwDMCbtOXGG5MmCSQdeMtPIFwop8x9sQ47EKfV0S4yEA8JthfwKLLWGbEk0dKIUaA3qVTMjq2fQ6n94FJNs5bx7UefitT+QykhZB0ldyr9D/Q3+Q6G1+TjWLqKgEy6VJxVeMi7UkB9CwkJaN+fasyIBHSx6YgSmiYHp+h8bUBdQv3/wHf0lmLGXoisCQAAAAASUVORK5CYII=" alt="" />
                </div>
              </div>
              <div className="customer">
                <div className="">
                  <img src="https://img.icons8.com/color/48/000000/user-female.png" alt="" />
                  <div className="">
                    <h4>Imma</h4>
                  </div>
                </div>
                <div className="">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA40lEQVRIS92V0QnCMBRFzxMaCPihE6gbOIKj2A26iSO0buIIukHdQEGoVDDSQktbq7WN+dD3mfDuyb0JL4LjEsf6lIBbYlYGQmBuCY0FfE/LLtMpAWliYmBmKV60x0rLogkw2YLSYhVbmpiaTtXBHwIKu133Uo21V0TOAV0nb9vv5cA54F1Er55zLwfOAc4j+l1AejFLRoQIyyEugKPSkk/lp1kE+Bg2CJOh4gLrtnGdD7tKbb0rgUzlNBCUt7U5OAOB0hLZCBe9dYDhwJ21Gsv+G+JNB9E3ImkezOr3+sSlc8ADYgSoGXBQY4YAAAAASUVORK5CYII=" alt="" />
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABdklEQVRIS9WV3VGDQBSFz00mSzYvagXGCtQKjBWYVKDpQCswdoAVmFSQWIHYAXZgB/IiCA5eZzMLAmEz/Jhx3Ed+zrdnOedC2PGiHevjbwCRzzYDhyLElA7Ia+My54DfeP+zjyWAkRZ1hKTzXwNEPrsgHBcE50LStCkk5yAKmA1CjSFVAQDjRgzIruukCHAAnJWJMOPRGtC4LWAO4HJDhPHSCzFqkqicg/Cdx9RZp+hntRBXImUxfQWwlxBi4EhKUtcarY0mRwHnjomBO0vSrJF60YESCQIedgE3dcHwYsJp0YUqZWThgTpwRJ/uTRsonUVhwDMCbtOXGG5MmCSQdeMtPIFwop8x9sQ47EKfV0S4yEA8JthfwKLLWGbEk0dKIUaA3qVTMjq2fQ6n94FJNs5bx7UefitT+QykhZB0ldyr9D/Q3+Q6G1+TjWLqKgEy6VJxVeMi7UkB9CwkJaN+fasyIBHSx6YgSmiYHp+h8bUBdQv3/wHf0lmLGXoisCQAAAAASUVORK5CYII=" alt="" />
                </div>
              </div>
              <div className="customer">
                <div className="">
                  <img src="https://img.icons8.com/dusk/64/000000/user-female.png" alt="" />
                  <div className="">
                    <h4>Harry Igles</h4>
                  </div>
                </div>
                <div className="">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA40lEQVRIS92V0QnCMBRFzxMaCPihE6gbOIKj2A26iSO0buIIukHdQEGoVDDSQktbq7WN+dD3mfDuyb0JL4LjEsf6lIBbYlYGQmBuCY0FfE/LLtMpAWliYmBmKV60x0rLogkw2YLSYhVbmpiaTtXBHwIKu133Uo21V0TOAV0nb9vv5cA54F1Er55zLwfOAc4j+l1AejFLRoQIyyEugKPSkk/lp1kE+Bg2CJOh4gLrtnGdD7tKbb0rgUzlNBCUt7U5OAOB0hLZCBe9dYDhwJ21Gsv+G+JNB9E3ImkezOr3+sSlc8ADYgSoGXBQY4YAAAAASUVORK5CYII=" alt="" />
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABdklEQVRIS9WV3VGDQBSFz00mSzYvagXGCtQKjBWYVKDpQCswdoAVmFSQWIHYAXZgB/IiCA5eZzMLAmEz/Jhx3Ed+zrdnOedC2PGiHevjbwCRzzYDhyLElA7Ia+My54DfeP+zjyWAkRZ1hKTzXwNEPrsgHBcE50LStCkk5yAKmA1CjSFVAQDjRgzIruukCHAAnJWJMOPRGtC4LWAO4HJDhPHSCzFqkqicg/Cdx9RZp+hntRBXImUxfQWwlxBi4EhKUtcarY0mRwHnjomBO0vSrJF60YESCQIedgE3dcHwYsJp0YUqZWThgTpwRJ/uTRsonUVhwDMCbtOXGG5MmCSQdeMtPIFwop8x9sQ47EKfV0S4yEA8JthfwKLLWGbEk0dKIUaA3qVTMjq2fQ6n94FJNs5bx7UefitT+QykhZB0ldyr9D/Q3+Q6G1+TjWLqKgEy6VJxVeMi7UkB9CwkJaN+fasyIBHSx6YgSmiYHp+h8bUBdQv3/wHf0lmLGXoisCQAAAAASUVORK5CYII=" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </main>
  )
}

export default Main
